"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function BrightnessPlus(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M11.804 3.475l1.917 2.886 3.396-.685c.329-.063.668.037.904.274.237.236.34.576.273.904l-.684 3.396 2.885 1.917a1 1 0 0 1 0 1.666L17.61 15.75l.684 3.395a.995.995 0 0 1-.273.904 1.004 1.004 0 0 1-.904.274l-3.396-.685-1.917 2.886a1.001 1.001 0 0 1-1.666 0L8.22 19.638l-3.395.685a1.006 1.006 0 0 1-.905-.274.995.995 0 0 1-.273-.904l.684-3.395-2.885-1.917a1.001 1.001 0 0 1 0-1.666l2.885-1.917-.684-3.396a.995.995 0 0 1 .273-.904c.238-.237.577-.338.905-.274l3.395.685 1.917-2.886c.37-.556 1.295-.556 1.666 0zm-.833 2.361L9.515 8.028a1.008 1.008 0 0 1-1.03.427l-2.58-.52.52 2.578c.08.4-.088.806-.426 1.031L3.807 13l2.192 1.456a1 1 0 0 1 .427 1.03l-.52 2.58 2.579-.52a1 1 0 0 1 1.03.426l1.456 2.192 1.456-2.193a1.003 1.003 0 0 1 1.03-.426l2.579.52-.52-2.579a1 1 0 0 1 .427-1.03L18.135 13l-2.192-1.456a1.002 1.002 0 0 1-.427-1.03l.52-2.58-2.58.521a1.008 1.008 0 0 1-1.03-.427l-1.455-2.192zm0 3.164a4 4 0 0 1 0 8V9zm10-9c.55 0 1 .45 1 1v1h1c.55 0 1 .45 1 1s-.45 1-1 1h-1v1c0 .55-.45 1-1 1s-1-.45-1-1V4h-1c-.55 0-1-.45-1-1s.45-1 1-1h1V1c0-.55.45-1 1-1z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = BrightnessPlus;
